import { combineReducers } from 'redux';
import * as dialog from './components/common/dialog';
import AdminApparelItemPartsReducer from './components/AdminApparelItemParts/AdminApparelItemParts.reducer';
import AdminApparelItemsReducer from './components/AdminApparelItems/AdminApparelItems.reducer';
import AdminDepartments from './components/AdminDepartments/AdminDepartments.reducer';
import AdminFormsReducer from './components/AdminForms/AdminForms.reducer';
import AdminHelpDeskReducer from './components/AdminHelpDesk/AdminHelpDesk.reducer';
import AdminPromotionalItemsReducer from './components/AdminPromotionalItems/AdminPromotionalItems.reducer';
import AdminSizeChartsReducer from './components/AdminSizeCharts/AdminSizeCharts.reducer';
import AdminUsersReducer from './components/AdminUsers/AdminUsers.reducer';
import ApparelEditorReducer from './components/ApparelEditor/ApparelEditor.reducer';
import ApproveReducer from './components/Approve/Approve.reducer';
import BrochureEditorReducer from './components/BrochureEditor/BrochureEditor.reducer';
import DepartmentReducer from './components/Department/Department.reducer';
import EditorReducer from './components/Editor/Editor.reducer';
import FavoritesReducer from './components/Favorites/Favorites.reducer';
import LayoutReducer from './components/Layout/Layout.reducer';
import LoginReducer from './components/Login/Login.reducer';
import MyUthealthEditorReducer from './components/MyUthealthEditor/MyUthealthEditor.reducer';
import NrcEditorReducer from './components/NrcEditor/NrcEditor.reducer';
import OrderReducer from './components/Order/Order.reducer';
import OrdersReducer from './components/Orders/Orders.reducer';
import PersonalLoginReducer from './components/PersonalLogin/PersonalLogin.reducer';
import PromotionalEditorReducer from './components/PromotionalEditor/PromotionalEditor.reducer';
import PunchoutReducer from './components/Punchout/Punchout.reducer';
import RejectReducer from './components/Reject/Reject.reducer';
import ReportsReducer from './components/Reports/Reports.reducer';
import RestorePasswordReducer from './components/RestorePassword/RestorePassword.reducer';
import SearchReducer from './components/Search/Search.reducer';
import ShoppingCartReducer from './components/ShoppingCart/ShoppingCart.reducer';
import StaticEditorReducer from './components/StaticEditor/StaticEditor.reducer';
import TemplateReducer from './components/Template/Template.reducer';
import TermOfUseReducer from './components/TermOfUse/TermOfUse.reducer';
import UthLandingReducer from './components/UthLanding/UthLanding.reducer';
import UtpLandingReducer from './components/UtpLanding/UtpLanding.reducer';

const reducer = combineReducers({
    adminApparelItemParts: AdminApparelItemPartsReducer,
    adminApparelItems: AdminApparelItemsReducer,
    adminDepartments: AdminDepartments,
    adminForms: AdminFormsReducer,
    adminHelpDesk: AdminHelpDeskReducer,
    adminPromotionalItems: AdminPromotionalItemsReducer,
    adminSizeCharts: AdminSizeChartsReducer,
    adminUsers: AdminUsersReducer,
    apparelEditor: ApparelEditorReducer,
    approve: ApproveReducer,
    brochureEditor: BrochureEditorReducer,
    department: DepartmentReducer,
    dialog: dialog.reducer,
    editor: EditorReducer,
    favorites: FavoritesReducer,
    layout: LayoutReducer,
    login: LoginReducer,
    myUthealthEditor: MyUthealthEditorReducer,
    nrcEditor: NrcEditorReducer,
    order: OrderReducer,
    orders: OrdersReducer,
    personalLogin: PersonalLoginReducer,
    promotionalEditor: PromotionalEditorReducer,
    punchout: PunchoutReducer,
    restorePassword: RestorePasswordReducer,
    reject: RejectReducer,
    reports: ReportsReducer,
    search: SearchReducer,
    shoppingCart: ShoppingCartReducer,
    staticEditor: StaticEditorReducer,
    template: TemplateReducer,
    termOfUse: TermOfUseReducer,
    uthLanding: UthLandingReducer,
    utpLanding: UtpLandingReducer,
});

export default reducer;
